import { useAuthStore } from '../store/useAuthStore';
import { clearCachedToken, clearLocalAuthCache } from '../utils/authUtils';

// Ends the chat session in this tab: drops every token from memory and
// cache and flags the session expired, which unmounts the chat behind
// SessionTimeoutGate. A reload runs the auth guard again for a fresh login.
// Other open chat tabs are deliberately left alone: each runs its own
// timeline, and one idle tab must not log out a tab the user is active in.
export const forceLogout = () => {
  window.__authTokenData__ = null;
  clearCachedToken();
  clearLocalAuthCache();
  useAuthStore.getState().expireSession();
};
